
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { HelpCircle, Shield, Crown, UserCircle, Gift, Archive, Bot, Building2, FolderKanban, Scale, BriefcaseBusiness, Image } from "lucide-react";
import { PLATFORM_FEE_COLLECTOR } from "@/utils/referralSystem";
import { useAccount } from 'wagmi';

export const MenuContent = () => {
  const navigate = useNavigate();
  const { address, isConnected } = useAccount();
  
  const isPlatformFeeCollector = address?.toLowerCase() === PLATFORM_FEE_COLLECTOR.toLowerCase();

  return (
    <div className="backdrop-blur-md bg-background/80 border border-border/20 rounded-lg p-2">
      <Dialog>
        <DialogTrigger asChild>
          <Button variant="ghost" className="w-full justify-start">
            <HelpCircle className="mr-2 h-4 w-4" />
            How it works
          </Button>
        </DialogTrigger>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle className="text-center mb-4">how it works</DialogTitle>
            <DialogDescription className="text-center space-y-4">
              <p>
                Matic Moon prevents rugs by making sure that all created tokens are safe. each coin on Matic Moon is a{" "}
                <span className="text-[#90EE90]">fair-launch</span> with{" "}
                <span className="text-[#87CEEB]">no presale</span> and{" "}
                <span className="text-[#FFA500]">no team allocation</span>.
              </p>
              <div className="space-y-2 mt-4">
                <p>step 1: pick a coin that you like</p>
                <p>step 2: buy the coin on the bonding curve</p>
                <p>step 3: sell at any time to lock in your profits or losses</p>
                <p>step 4: when enough people buy on the bonding curve it reaches a market cap of $100k</p>
                <p>step 5: $17k of liquidity is then deposited in QuickSwap and burned</p>
              </div>
              <Button className="mt-6 w-full">I'm ready to pump</Button>
            </DialogDescription>
          </DialogHeader>
        </DialogContent>
      </Dialog>
      {isConnected && (
        <Button variant="ghost" className="w-full justify-start" onClick={() => navigate(`/profile/${address}`)}>
          <UserCircle className="mr-2 h-4 w-4" />
          Profile
        </Button>
      )}
      {isConnected && (
        <Button variant="ghost" className="w-full justify-start" onClick={() => navigate('/referrals')}>
          <Gift className="mr-2 h-4 w-4" />
          Referral Earnings
        </Button>
      )}
      <Button variant="ghost" className="w-full justify-start" onClick={() => navigate('/king-of-the-bots')}>
        <Crown className="mr-2 h-4 w-4" />
        King of the Bots
      </Button>
      <Button variant="ghost" className="w-full justify-start" onClick={() => navigate('/inception')}>
        <Archive className="mr-2 h-4 w-4" />
        Inception Tokens
      </Button>
      <Button variant="ghost" className="w-full justify-start" onClick={() => navigate('/nfts')}>
        <Image className="mr-2 h-4 w-4" />NFT Studio
      </Button>
      <Button variant="ghost" className="w-full justify-start" onClick={() => navigate('/entities')}>
        <Building2 className="mr-2 h-4 w-4" />Entities
      </Button>
      <Button variant="ghost" className="w-full justify-start" onClick={() => navigate('/agents')}>
        <Bot className="mr-2 h-4 w-4" />Agents
      </Button>
      <Button variant="ghost" className="w-full justify-start" onClick={() => navigate('/projects')}>
        <FolderKanban className="mr-2 h-4 w-4" />Trust Profiles
      </Button>
      <Button variant="ghost" className="w-full justify-start" onClick={() => navigate('/validators')}>
        <Scale className="mr-2 h-4 w-4" />Validators
      </Button>
      <Button variant="ghost" className="w-full justify-start" onClick={() => navigate('/services')}>
        <BriefcaseBusiness className="mr-2 h-4 w-4" />Services
      </Button>
      <Button variant="ghost" className="w-full justify-start" onClick={() => navigate('/analytics')}>
        Analytics
      </Button>
      <Button variant="ghost" className="w-full justify-start" onClick={() => navigate('/advanced')}>
        Advanced
      </Button>
      {isPlatformFeeCollector && (
        <>
          <Button variant="ghost" className="w-full justify-start" onClick={() => navigate('/referral-codes')}>
            <Gift className="mr-2 h-4 w-4" />
            Manage Referrals
          </Button>
          <Button variant="ghost" className="w-full justify-start" onClick={() => navigate('/platform-metrics')}>
            Platform Metrics
          </Button>
        </>
      )}
      <Button variant="ghost" className="w-full justify-start">
        Support
      </Button>
    </div>
  );
};
